import { Component, OnInit } from '@angular/core';
import { TonnageRatingDataResponse } from '../../model/tonnage/tonnage-rating-response.model';
import { TonnageService } from '../../services/tonnage/tonnage.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TonnageRating } from '../../model/tonnage/tonnage-rating.model';
import { ActivatedRoute } from '@angular/router';
import  { TabService } from '../../services/tab.service';

@Component({
  selector: 'lms-lms-tonnage',
  templateUrl: './lms-tonnage.component.html',
  styleUrls: ['./lms-tonnage.component.scss']
})
export class LmsTonnageComponent implements OnInit {
  self = this; 


 unsubscribe: Subject<void> = new Subject();

  fetchedTonnageRatings: TonnageRatingDataResponse;
  tonnageRatingHandlerData: TonnageRating[];


  isLmpsSelected: boolean = true;
 
  showLMPS: boolean = false;


  searchedTrain: string = null;

  // these are column/headers will be displayed in UI table and generated excel file
  //use | for multple values in header
  lmpsHeadings =  ["Sequence", "Departure", "Time", "Arrive","Time","Miles", "MP15|GP15-1|GP15T", "3GS21B|RDSLUG|B20-8|B40-8|GP38-2|GP40-2",
                               "SD50-2|SD50-3|SD40-2","SD50","SD70M|SD60|CW44-9|CW40-9|CW40-8|C40-8","ES40DC|ES44DC|ES44C4|ET44C4","SD70AE|SD70AC|SD70MA",
                               "CW44AC|CW46AC|CW44-6|CW60AC|ET44AC|SD80AC|SD90AC","CW44AH|CW46AH|CW60AH|ES44AH|ET44AH"];

   constructor(private tonageService: TonnageService,
              private _ActivatedRoute: ActivatedRoute,              
              private tabService: TabService) {

    this._ActivatedRoute.data.subscribe(data => {
      const search = data?.tabData?.length > 0
        ? data?.tabData[0]?.tabSearchParameter?.searchText
        : null;
      if(search) {
        this.searchedTrain = search;
      }
    });


   };


  ngOnInit() {
    this.initSubscriptions()
    if(this.searchedTrain){
      this.searchLMPSTonnage(this.searchedTrain);
    }  

  }
  initSubscriptions() {
      this.tabService.tabStoreObservable.pipe(takeUntil(this.unsubscribe)).subscribe(tabs => {
        const selectedTabs = tabs.filter(x => x.selected);
          if(selectedTabs.length > 0) {
            const selectedTab = selectedTabs[0];
            const searchText = selectedTab?.tabSearchParameter?.searchText;
            if(selectedTab.subType == "Profile" && searchText) {
              this.searchedTrain = searchText;
              this.searchLMPSTonnage(this.searchedTrain);
            }
          }
        });    
  }

  searchLMPSTonnage(trainId: string){
    this.tonageService.fetchTonnageLMPS(trainId).subscribe({
      next: (fetchedTonnage: TonnageRatingDataResponse)=>{
        this.showLMPS = true;
        this.tonnageRatingHandlerData = fetchedTonnage.tonnageRatingHandlerData;
      },
      error: ()=>{

      }
    });
  }

  public isResultsAvailable() {
    return (this.tonnageRatingHandlerData?.length > 0 && ( this.showLMPS));
  }

  
   private isEmpty(arr: any[]): boolean {
     if (arr === undefined || arr === null) {
       return true;
     }
     return arr.length === 0;
   }
 
   ngOnDestroy() {
      this.unsubscribe.next();
      this.unsubscribe.complete();
    }
}


